import React from 'react';

export default function Screenshots() {
  return (
    <section className="section section--muted" id="screenshots">
      <h2 className="section__title">See it in action</h2>
      <div className="how-it-works">
        <span className="chip chip--step">Listen → Repeat → Role play</span>
        <span className="chip chip--step">Reveal answers only after trying</span>
        <span className="chip chip--step">Save lines for later</span>
      </div>
      <div className="screenshot-grid">
        <figure className="screenshot-card">
          <img
            src="/screenshots/conversation.jpg"
            alt="ConvoLines conversation screen showing a dialogue practised line by line"
            width={580}
            height={1260}
            loading="lazy"
          />
          <figcaption>Practice full conversations line by line.</figcaption>
        </figure>
        <figure className="screenshot-card">
          <img
            src="/screenshots/expressions.jpg"
            alt="ConvoLines quiz screen revealing two natural answers to a spoken English cue"
            width={580}
            height={1260}
            loading="lazy"
          />
          <figcaption>Learn natural answers for real situations.</figcaption>
        </figure>
      </div>
    </section>
  );
}
